import { Bomb, Flame, ReceiptText, Skull, GaugeCircle, Unplug } from "lucide-react";
import { Chapter, Reveal } from "./shared";
import { useSiteConfig } from "@/context/SiteConfigContext";

const RISKS = [
  { icon: Bomb, title: "Explosões", desc: "Risco de explosões que podem destruir ambientes." },
  { icon: Flame, title: "Incêndios", desc: "Vazamentos podem provocar incêndios graves." },
  { icon: ReceiptText, title: "Conta alta", desc: "Perda de gás gera desperdício e contas muito mais caras." },
  { icon: Skull, title: "Intoxicação", desc: "Gás pode causar intoxicação e colocar vidas em risco." },
  { icon: GaugeCircle, title: "Perda de pressão", desc: "Equipamentos não funcionam corretamente e causam transtornos." },
  { icon: Unplug, title: "Danos na tubulação", desc: "Vazamentos corroem a tubulação e causam prejuízos maiores." },
];

export const Risks = () => {
  const cfg = useSiteConfig();
  const risks = cfg.risks?.length ? cfg.risks : RISKS;

  return (
  <section className="hero-fire bg-[var(--dark-bg)] py-24 sm:py-32" data-testid="risks-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Chapter dark num="02 — Riscos reais" title="O que pode acontecer se você" accent="ignorar um vazamento?" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        {risks.map((r, i) => {
          const IconCmp = RISKS[i % RISKS.length].icon;
          return (
          <Reveal key={i} delay={i * 0.08}>
            <div
              data-testid={`risk-card-${i}`}
              className="group h-full rounded-2xl border border-white/5 bg-[#12141A] p-6 text-center transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-red-500/40"
            >
              <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-500/10 transition-colors duration-300 group-hover:bg-red-500/20">
                <IconCmp size={26} className="text-red-500" />
              </span>
              <h3 className="font-display text-lg font-bold uppercase leading-tight text-white">{r.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-zinc-500">{r.desc}</p>
            </div>
          </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.3} className="mt-12 text-center">
        <a
          href="#contato"
          data-testid="risks-cta-button"
          className="inline-block rounded-full bg-[var(--danger)] px-9 py-4 font-display text-base font-bold uppercase tracking-wider text-white shadow-[0_8px_40px_rgba(229,72,77,0.35)] transition-transform duration-300 hover:scale-105"
        >
          Solicitar Inspeção Preventiva
        </a>
      </Reveal>
    </div>
  </section>
  );
};
